import $ from 'jquery'

const modal = $('.js-petition-letter-popup')
const trigger = $('.js-petition-letter-trigger')
const close = $('.js-petition-letter-close')

trigger.on('click', () => {
    modal.removeClass('u-hidden')
})

close.on('click', () => {
    modal.addClass('u-hidden')
})
